import dayjs from "@/lib/helpers/dayjs";

const DATE_FORMAT = "M/D/YY";

export function getFormattedAcuityDate(acuityTimestamp: string) {
  return dayjs(acuityTimestamp).format(DATE_FORMAT);
}
